import * as React from "react"
const Bird = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <g clipPath="url(#bird)">
      <path
        fill="#fff"
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m6.802 21.32 2.087-2.086a1.75 1.75 0 0 1 2.475 2.474L9.532 23.54a1.657 1.657 0 0 0-.33 1.872 1.657 1.657 0 0 1-.897 2.243l-.338.133a1.799 1.799 0 0 1-2.432-1.395l-.043-.27a1.376 1.376 0 0 0-.997-1.113 1.376 1.376 0 0 1-1.012-1.42l.011-.157a1.57 1.57 0 0 1 1.462-1.462l.484-.033a2.125 2.125 0 0 0 1.362-.617Z"
      />
      <path
        fill="#DA8059"
        stroke="#010101"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M24.799 5.799C19.04.04 12.562 7.429 12.778 10.04c0 0-6.718 4.596-1.768 9.546 4.95 4.95 9.546-1.768 9.546-1.768 2.612.216 10-6.263 4.243-12.02Z"
      />
      <circle
        cx={22.745}
        cy={9.353}
        r={1}
        fill="#010101"
        transform="rotate(-60 22.745 9.353)"
      />
      <circle
        cx={14.967}
        cy={17.131}
        r={1}
        fill="#010101"
        transform="rotate(-60 14.967 17.131)"
      />
      <circle
        cx={16.769}
        cy={10.326}
        r={1}
        fill="#010101"
        transform="rotate(-60 16.769 10.326)"
      />
    </g>
    <defs>
      <clipPath id="bird">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Bird
